import validateVar from "./validation/validateVariable";

function fill_value_if_not_existing(value, default_vaue){
    if (validateVar(value)) return value;
    else if (validateVar(default_vaue)) return default_vaue;
    else return "";
}
export default fill_value_if_not_existing;